<template>
  <div v-if="isDisplay" class="mask-layer" @click="openDialog">
    <div v-show="dialogVisible" class="dialog">
        <div class="tips">
            <p>当前应用不支持该活动</p>
            <p>请使用正确的应用打开</p>
        </div>
        <div class="btn" @click.stop="closeDialog">我知道了</div>
    </div>
  </div>
</template>

<script>
import { LoginType } from '../../../../commons/commonVariables';
export default {
    props: {
        // 是否展示组件
        isDisplay: {
            type: Boolean,
            default: false
        },
        // 活动的登录类型
        loginType: {
            type: String,
            default: 'none'
        }
    },
    data() {
        return {
            dialogVisible: true,
        }
    },
    computed: {
        
    },
    methods: {
        openDialog(){
            this.dialogVisible = true;
        },
        closeDialog(){
            this.dialogVisible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
.mask-layer{
    width: 100vw;
    height: 100vh;
    background: rgba($color: #000000, $alpha: 0.6);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    .dialog{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        background-image: linear-gradient(180deg, #FFFFFF 0%, #c4d7fb 100%);
        border-radius: 12px;
        padding-top: 6.93vw;
        width: 69.5vw;
        .tips{
            font-family: HONORSansBrand-Regular;
            font-size: 14px;
            color: #000000;
            text-align: center;
            line-height: 22px;
            font-weight: 400;
        }
        .btn{
            border: 1px solid #256FFF;
            border-radius: 22px;
            width: 34.7vw;
            text-align: center;
            padding: 8px;
            margin: 6.04vw auto 6.46vw auto;
            font-family: HONORSansBrand-Regular;
            font-size: 14px;
            color: #256FFF;
            letter-spacing: 0;
            font-weight: 400;
        }
    }
}
</style>>

</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/incorrect-client.vue